<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.idn_character_sets.form.labels.name')"
            :is-required="true"
            :error="errors.name"
            :hint="__('settings.idn_character_sets.form.labels.name_hint')"
        >
            <DInput
                id="name"
                v-model="form.name"
                add-input-classes="bg-light"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.idn_character_sets.form.labels.characters')"
            :is-required="true"
            :error="errors.characters"
            :hint="__('settings.idn_character_sets.form.labels.characters_hint')"
        >
            <DFormTextarea
                id="characters"
                v-model="form.characters"
                rows="4"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.idn_character_sets.form.labels.description')"
            :error="errors.description"
            :hint="__('settings.idn_character_sets.form.labels.description_hint')"
        >
            <DInput
                id="description"
                v-model="form.description"
                add-input-classes="bg-light"
                maxlength="255"
            />
        </DFormRow>
        <DFormControls
            :cancel-route="getIndex()"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
    </DForm>
</template>

<script setup>
import { route } from '~@/Composables/route'
import { useForm } from '@inertiajs/vue3'

const props = defineProps({
    errors: {
        type: Object,
        default: () => {
            return {}
        }
    },
    idnCharacterSet: {
        type: Object,
        default: () => {
            return {}
        }
    }
})

const emit = defineEmits(['form-submitted'])

const form = useForm({
    name: props.idnCharacterSet?.name,
    characters: props.idnCharacterSet?.characters,
    description: props.idnCharacterSet?.description
})

function submitForm () {
    emit('form-submitted', form)
}

function getIndex () {
    return route('settings.idn-character-sets.index')
}
</script>
